<app-funcionario-modal
  [isOpen]="modalFuncionarioAberto"
  (closeModal)="onFuncionarioSelecionado($event)"
></app-funcionario-modal>


<section class="usuario-shell">
  <header class="usuario-hero">
    <div>
      <h2 class="usuario-title">{{ modoEdicao ? 'Editar Usuário' : 'Novo Usuário' }}</h2>
      <p class="usuario-subtitle">{{ modoEdicao ? 'Atualize os dados do usuário selecionado.' : 'Preencha os dados para criar um novo usuário no sistema.' }}</p>
    </div>
    <span class="usuario-chip">{{ modoEdicao ? 'Edição' : 'Cadastro' }}</span>
  </header>

  <form [formGroup]="usuarioForm" class="usuario-card">
    <div class="form-section">
      <h3>Dados de Acesso</h3>
      <div class="row g-3">
        <div class="col-md-4">
          <label for="nomeUsuario" class="form-label">Nome de Usuário</label>
          <input
            id="nomeUsuario"
            type="text"
            class="form-control"
            formControlName="nomeUsuario"
            [class.is-invalid]="usuarioForm.get('nomeUsuario')?.invalid && usuarioForm.get('nomeUsuario')?.touched"
          />
          <div class="invalid-feedback">Campo obrigatório.</div>
        </div>

        <div class="col-md-8">
          <label for="nomeCompleto" class="form-label">Nome Completo</label>
          <input
            id="nomeCompleto"
            type="text"
            class="form-control"
            formControlName="nomeCompleto"
            [class.is-invalid]="usuarioForm.get('nomeCompleto')?.invalid && usuarioForm.get('nomeCompleto')?.touched"
          />
          <div class="invalid-feedback">Campo obrigatório.</div>
        </div>

        <div class="col-md-6">
          <label for="email" class="form-label">E-mail</label>
          <input
            id="email"
            type="email"
            class="form-control"
            formControlName="email"
            [class.is-invalid]="usuarioForm.get('email')?.invalid && usuarioForm.get('email')?.touched"
          />
          <div class="invalid-feedback">Informe um e-mail válido.</div>
        </div>

        <div class="col-md-3 d-flex align-items-end">
          <div class="form-check form-switch mb-2">
            <input id="ativo" class="form-check-input" type="checkbox" formControlName="ativo" />
            <label class="form-check-label" for="ativo">Usuário Ativo</label>
          </div>
        </div>
      </div>
    </div>

    <div class="form-section">
      <h3>Segurança</h3>
      <div class="row g-3">
        <div class="col-md-6">
          <label for="secret" class="form-label">Senha</label>
          <input
            id="secret"
            type="password"
            class="form-control"
            formControlName="secret"
            [placeholder]="modoEdicao ? 'Deixe em branco para manter a senha atual' : ''"
            [class.is-invalid]="usuarioForm.get('secret')?.invalid && usuarioForm.get('secret')?.touched"
          />
          <div class="invalid-feedback" *ngIf="!modoEdicao">Campo obrigatório.</div>
        </div>
      </div>
    </div>

    <div class="form-section">
      <h3>Funcionário Vinculado</h3>
      <div class="row g-3">
        <div class="col-md-8">
          <label for="nomeFuncionario" class="form-label">Funcionário</label>
          <input
            id="nomeFuncionario"
            type="text"
            class="form-control"
            [value]="nomeFuncionarioSelecionado"
            readonly
            style="background-color: #e9ecef;"
            [class.is-invalid]="usuarioForm.get('idFuncionario')?.invalid && usuarioForm.get('idFuncionario')?.touched"
            placeholder="Nenhum funcionário selecionado"
          />
          <div class="invalid-feedback">Selecione um funcionário.</div>
        </div>
        <div class="col-md-4 d-flex align-items-end">
          <button type="button" class="btn btn-outline-primary w-100" (click)="modalFuncionarioAberto = true">
            <i class="bi bi-person-badge me-1"></i> Selecionar Funcionário
          </button>
        </div>
      </div>
    </div>
  </form>

  <footer class="action-bar">
    <button type="button" class="btn btn-outline-secondary" (click)="voltar()" [disabled]="isLoading">
      Voltar
    </button>
    <button type="button" class="btn btn-primary" (click)="salvar()" [disabled]="isLoading || usuarioForm.invalid">
      {{ isLoading ? 'Salvando...' : (modoEdicao ? 'Salvar Alterações' : 'Criar Usuário') }}
    </button>
  </footer>
</section>

